import { IconBaseProps } from '@vertex-protocol/web-ui';

export function BnbLogoIcon(props: IconBaseProps) {
  return (
    <svg
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.53487 3.1621L2.27763 2.43422L5.78467 0.382935L9.29171 2.43422L8.03447 3.1621L5.78467 1.90486L3.53487 3.1621ZM10.2181 4.41934V5.94126L11.4753 5.21338V3.69146L10.2181 2.96359L8.96085 3.69146L10.2181 4.41934ZM4.52743 3.69146L5.78467 4.41934L7.04191 3.69146L5.78467 2.96359L4.52743 3.69146ZM9.29171 4.9487L8.03447 4.22083L5.78467 5.47807L3.53487 4.22083L2.27763 4.9487V6.47062L4.52743 7.72786V10.3085L5.78467 11.0364L7.04191 10.3085V7.72786L9.29171 6.47062V4.9487ZM10.2181 9.58064L8.03447 10.8379V12.3598L11.5415 10.3085V6.27211L10.2181 6.99999V9.58064ZM8.03447 9.77915L9.29171 9.05127V7.52935L8.03447 8.25723V9.77915ZM4.52743 11.3672V12.8892L5.78467 13.617L7.04191 12.8892V11.3672L5.78467 12.0951L4.52743 11.3672ZM0.027832 5.21338L1.28507 5.94126V4.41934L2.60848 3.69146L1.35124 2.96359L0.027832 3.69146V5.21338ZM1.35124 6.99999L0.0940022 6.27211V10.3085L3.60104 12.3598V10.8379L1.35124 9.58064V6.99999ZM3.53487 8.25723L2.27763 7.52935V9.05127L3.53487 9.77915V8.25723Z"
        fill="currentColor"
      />
    </svg>
  );
}
